export * from '@nunc/services/config/config.module';
export * from '@nunc/services/config/config.service';
